// extracted by mini-css-extract-plugin
export default {"bar":"SaveBar_bar__F4nsx","text":"SaveBar_text__cbCQ6","detail":"SaveBar_detail__+U9E1","actions":"SaveBar_actions__fhDXR"};